import React, { useRef, useEffect, useState } from 'react';
import moment from 'moment';
import TenantService from "../../../api/tenant.service"
import AssetsService from '../../../api/assets.service';

import Form, { SimpleItem, Label } from 'devextreme-react/form';
import { Item as AssetTabItem } from 'devextreme-react/form';
import { useHistory } from "react-router";
import Toast from 'components/Toast';


export default function EditTab({assetId}) {
    const [saveChangedOG, setSaveChangedOG] = useState([]);
    const [saveChanged, setSaveChanged] = useState([]);
    const [editedFlag, setEditedFlag] = useState(false);
    const [fieldDataOG, setFieldDataOG] = useState();
    const [types, setTypes] = useState([]);
    const [devices, setDevices] = useState([]);
    const [fieldData, setFieldData] = useState();
    const form = useRef(null);
    const [editAllowed, setEditAllowed] = useState(false);
    const [fields, setFields] = useState([]);
    const history = useHistory();
    const [pageName, setPageName] = useState("");
    const tenant = TenantService.getTenant();
    const [checkBoxValue, setCheckBoxValue] = useState(false);
    const [lastPositionUpdateTime, setLastPositionUpdateTime] = useState("");
    const [deviceType, setDeviceType] = useState(null);
    const [assetType, setAssetType] = useState(null);

    const [toastConfig, setToastConfig] = React.useState({
        isVisible: false,
        type: 'info',
        message: '',
        displayTime: 5000,
    });

    useEffect(() => {
        getData()
        getTypes()
        checkRole()
    }, []);

    function checkRole() {
        var role = JSON.parse(localStorage.getItem("role"));
        let canEdit = false
        for (let i = 0; i < role.length; i++) {
            if (role[i].name === "Asset Attributes") {
                if (role[i].write === true) {
                    canEdit = true
                }
            }
        }
        if (canEdit) {
            setEditAllowed(true)
        }
    }


    function onFieldDataChangedOG(e) {
        let existingDataOG = saveChangedOG
        let didExist = false
        for (let i = 0; i < existingDataOG.length; i++) {
            if (existingDataOG[i].key === e.dataField) {
                existingDataOG[i].value = e.value
                didExist = true
            }
        }
        if (!didExist) {
            existingDataOG.push({
                "key": e.dataField,
                "value": e.value
            })
            setSaveChanged(existingDataOG)
        } else {
            setSaveChangedOG(existingDataOG)
        }
        setEditedFlag(true)
    }

    const typeEditorOptions = {
        dataSource: types,
        searchEnabled: true,
        displayExpr: "name",
        valueExpr: "id",
    };

    const deviceEditorOptions = {
        dataSource: devices,
        searchEnabled: true,
        displayExpr: "serialNumber",
        valueExpr: "id",
        placeholder: "Unpaired"
    };

    function onFieldDataChanged(e) {
        let existingData = saveChanged
        let didExist = false
        for (let i = 0; i < existingData.length; i++) {
            if (existingData[i].key === e.dataField) {
                existingData[i].value = e.value
                didExist = true
            }
        }
        if (!didExist) {
            existingData.push({
                "key": e.dataField,
                "value": e.value
            })
            setSaveChanged(existingData)
        } else {
            setSaveChanged(existingData)
        }
        setEditedFlag(true)
    }

    function onClick(type) {
        for (let i = 0; i < saveChangedOG.length; i++) {
            editAsset(saveChangedOG[i].key, saveChangedOG[i].value)
        }
        for (let i = 0; i < saveChanged.length; i++) {
            editAsset(saveChanged[i].key, saveChanged[i].value)
        }
        setEditedFlag(false)
    }

    function editAsset(key, value) {
        // console.log('SELECTED TAB INDEX: ', selectedTabIndex);
        // console.log('KEY', key);
        // console.log('KEY', value);
        // setLoading(true)
        let id = assetId
        let name
        let typeId
        let pairedDevice
        let attributes
        if (key === "name") {
            name = value
        } else if (key === "type.id") {
            typeId = value
            getTypeAttributes(typeId)
        } else if (key === "pairedDevice.id") {
            pairedDevice = value
        } else {
            var dynamicKey = key;
            let payload = {}
            payload[dynamicKey] = value
            attributes = payload
        }
        AssetsService.editAsset(id, name, typeId, pairedDevice, attributes).then((value) => {
            // setLoading(false)
            if (value.status === 200) {
                setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: 'success',
                    message: "Edit successful",
                    status: 200,
                });
                // if (selectedTabIndex === 5 && tenant === PE_TENANT_ID) {
                //     setDaysToMaintenance(value.data.data.daysToMaintenance)
                //     setMaintenanceStatus(value.data.data.maintenanceStatus)
                //     getData()
                // }
            } else {
                setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: 'error',
                    message: "Edit unsuccessful",
                    status: 500,
                });
            }
        })
    }

    function goBack() {
        history.push({
            pathname: `/assets/`,
            state: {
                response: ""
            }
        })
    }

    function getTypeAttributes(typeId) {
        AssetsService.getAssetTypeAttributes(typeId).then((value) => {
            let response = value.data
            setFields(response.data)
            setFieldData([])
        })
    }

    function getTypes() {
        AssetsService.getAssetTenantTypes(tenant).then((value) => {
            let response = value.data
            setTypes(response.data)
        })
    }

    function getData() {
        AssetsService.getAsset(assetId).then((value) => {
            let data = value.data.data
            setPageName(data.name)
            if (data.info !== null) {
                setCheckBoxValue(data.info.checkInState.value)
            }
            if (data.info !== null) {
                setCheckBoxValue(data.info.checkInState.value)
            }
            if (data.lastKnownLocation && data.lastKnownLocation.timestamp) {
                setLastPositionUpdateTime(moment(data.lastKnownLocation.timestamp).format("YYYY-MM-DD HH:mm"))
                // handleDwellTime(data?.dwellStart)
            } else {
                setLastPositionUpdateTime("None")
                // setLatestDwellTime("None")
            }
            // if (tenant === PE_TENANT_ID) {
            //     const allowedKeys = ["last_maintenance_date", "maintenance_period"];
            //     const extractedKeys = Object.keys(data.attributes).filter(key => allowedKeys.includes(key));
            //     setAttributes(extractedKeys);
            //     setDaysToMaintenance(data.daysToMaintenance)
            //     setMaintenanceStatus(data.maintenanceStatus)
            // }

            // if (tenant === PE_TENANT_ID){
            //     const allowedKeys = ["last_maintenance_date", "maintenance_period"];
            //     const extractedKeys = Object.keys(data.attributes).filter(key => allowedKeys.includes(key));
            //     setAttributes(extractedKeys);
            //     if (data?.attributes?.last_maintenance_date){
            //         debugger
            //         const [month, day, year] = data.attributes.last_maintenance_date.split("/"); // Ensure it's MM/DD/YYYY
            //         const parsedDate = new Date(Number(year), Number(month) - 1, Number(day)); // Month is 0-based in JS
            //         console.log('PArSED DATE: ', parsedDate);

            //         setLastMaintenanceDate(parsedDate);

            //         setMaintenancePeriod(parseInt(data?.attributes?.maintenance_period))
            //         // setTimeout(() => {
            //         //     calculateMaintenanceStatus();
            //         // }, 5000);

            //     }
            // }

            setFieldData(data.attributes)
            setFieldDataOG(data)
            setDeviceType(data.pairedDevice.deviceType)
            setAssetType(data.type.id)

            let currentDeviceSerial = data.pairedDevice.serialNumber
            AssetsService.getAssetTagsToPair(tenant).then((value) => {
                let response = value.data
                let serials = []
                let serialsId = []
                serials.push({
                    "serialNumber": "Unpaired",
                    "id": null
                })
                serialsId.push(null)
                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].freeToPair || response.data[i].serialNumber === currentDeviceSerial) {
                        serials.push({
                            "serialNumber": response.data[i].serialNumber,
                            "id": response.data[i].id
                        })
                        serialsId.push(response.data[i].id)
                    }
                }
                setDevices(serials)
            })
        })
    }


    return (
        <>
            <Toast
                setParentToastConfig={setToastConfig}
                toastBody={toastConfig}
            />
            <div className='assetForm'>
                <div className='assetTab-topForm'>
                    <Form
                        onFieldDataChanged={onFieldDataChangedOG}
                        formData={fieldDataOG}
                        labelLocation={"left"}
                        labelMode={"outside"}
                    >
                        <SimpleItem dataField="name" />
                        <AssetTabItem dataField="type.id"
                            editorType="dxSelectBox" editorOptions={typeEditorOptions}>
                            <Label text="Type" />
                        </AssetTabItem>
                        <AssetTabItem dataField="pairedDevice.id"
                            editorType="dxSelectBox" editorOptions={deviceEditorOptions}>
                            <Label text="Paired Tag" />
                        </AssetTabItem>
                    </Form>
                </div>
                <div className='assetTab-bottomForm'>
                    <h2 className='assetTabh2'> Attributes</h2>
                    <Form
                        onFieldDataChanged={onFieldDataChanged}
                        formData={fieldData}
                        ref={form}
                        disabled={!editAllowed}
                        labelLocation={"left"}
                        labelMode={"outside"}
                    >
                        {fields.map((field, i) =>
                            <SimpleItem
                                key={i}
                                dataField={`${field.name}`}
                            >
                            </SimpleItem>
                        )}
                    </Form>
                    {/* <div style={{cursor: "pointer"}} className='profile-save' onClick={onClick}>
                                Save
                            </div> */}
                    <div style={{ marginTop: "40px" }}>
                        {/* <Button
                              width={"160px"}
                              type="normal"
                              stylingMode="outlined"
                              onClick={onClick}
                              text="Save"
                            /> */}
                        <div>
                            <button className='profile-save' onClick={onClick}>SAVE</button>
                            <button className='profile-save' onClick={goBack}>CANCEL</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}